import React from 'react';
import { Text, Title, Button, Container } from '@soluto-design/react';
import { LinkProps } from '@soluto-design/link';
import { PictureProps } from '@soluto-design/picture';
import Media, { MediaProps } from '../../molecules/Media';
import cls from '@soluto-design/styles/cls';

export interface BannerSmallSectionProps {
    logo: PictureProps;
    title: string;
    text?: string;
    media?: MediaProps['media'];
    cta?: LinkProps;
}

export default function BannerSmallSection({
    logo,
    title,
    text,
    media,
    cta,
}: BannerSmallSectionProps) {
    return (
        <section className="my-xxxl">
            <Container className="row">
                <div
                    data-theme="dark"
                    className={cls(
                        'rounded-large col-span-full flex flex-col gap-[56px] lg:flex-row xl:grid xl:grid-cols-subgrid xl:gap-gutter hd:flex hd:gap-[96px] p-24 md:p-40 xl:p-0 hd:p-48',
                    )}>
                    <div className="lg:basis-[47%] hd:basis-1/3 flex md:hidden lg:flex  items-center justify-center xl:col-span-5 xl:py-48 xl:pl-48 hd:p-0">
                        {!!media && (
                            <div
                                className={cls(
                                    'rounded-medium w-full h-auto px-[25%] aspect-square bg-background-secondary flex items-center justify-center',
                                )}>
                                <Media
                                    media={media}
                                    {...(!media.isImage && { autoPlay: true })}
                                    className="w-full h-auto"
                                    layout="responsive"
                                />
                            </div>
                        )}
                    </div>

                    <div
                        className={cls(
                            'lg:basis-[53%] hd:basis-2/3 col-span-full xl:col-span-6 xl:col-start-7 hd:max-w-[532px] flex flex-col xl:py-48 xl:pr-48 hd:p-0 items-start',
                        )}>
                        {!!logo && (
                            <img
                                src={logo}
                                alt="Logo"
                                className="h-24 w-auto mb-sm"
                            />
                        )}
                        {!!title && (
                            <Title
                                component="h4"
                                className="text-h300 text-text-primary pb-lg">
                                {title}
                            </Title>
                        )}
                        {!!text && (
                            <Text
                                isHtml
                                component="div"
                                className={cls(
                                    'text-b300 text-text-secondary',
                                    cta && 'lg:mb-64',
                                )}>
                                {text}
                            </Text>
                        )}
                        {!!cta && (
                            <Button
                                {...cta}
                                variant="primary"
                                size="large"
                                className="mt-64 lg:mt-auto"
                            />
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
}
